import React, { useCallback, useState } from 'react';
import { Alert, Snackbar } from '@mui/material';

export default function useDashboardNotifier() {
    const [snack, setSnack] = useState({ open: false, message: '', severity: 'success' });
    const notify = useCallback((message, severity = 'success') => {
        setSnack({ open: true, message, severity });
    }, []);
    const close = (_, reason) => {
        if (reason === 'clickaway') return;
        setSnack(previous => ({ ...previous, open: false }));
    };
    const notification = (
        <Snackbar open={snack.open} autoHideDuration={6000} onClose={close}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
            <Alert severity={snack.severity} variant="filled" onClose={close} sx={{ width: '100%' }}>
                {snack.message}
            </Alert>
        </Snackbar>
    );
    return { notify, notification };
}
